// extracted by mini-css-extract-plugin
export default {"wrapper":"DeviceWarning_wrapper__rfX98"};